import React from 'react';
import { revivalOfBuddhism } from '../data/mock';

const Initiatives = () => {
  return (
    <section id="initiatives" className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {revivalOfBuddhism.title}
          </h2>
          <p className="text-xl font-semibold text-blue-600 mb-6">
            {revivalOfBuddhism.subtitle}
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            {revivalOfBuddhism.content}
          </p>
        </div>

        {/* Initiatives Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {revivalOfBuddhism.initiatives.map((initiative, index) => {
            const colors = [
              'border-blue-600',
              'border-yellow-600',
              'border-red-600',
              'border-orange-600',
              'border-green-600',
              'border-purple-600'
            ];
            const borderColor = colors[index % colors.length];

            return (
              <div 
                key={index}
                className={`group bg-white rounded-xl shadow-lg overflow-hidden transform hover:-translate-y-2 transition-all duration-300 border-t-4 ${borderColor}`}
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={initiative.image} 
                    alt={initiative.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                    {initiative.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    {initiative.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl shadow-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">
            Be Part of the Buddhist Revival Movement
          </h3>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Join us in our mission to spread the teachings of Buddha and create a more just, equal, and compassionate society.
          </p>
          <button 
            onClick={() => document.getElementById('volunteer').scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300"
          >
            Become a Volunteer
          </button>
        </div>
      </div>
    </section>
  );
};

export default Initiatives;
